import { configureGetErrorMessage, configureGetErrorTitle } from 'error-messaging-js';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
const getErrorTitle = configureGetErrorTitle({
  logSentry: true
});
const getErrorMessage = configureGetErrorMessage({
  logSentry: true
});
const getErrorData = ({
  action,
  options,
  response = {
    responseJSON: {
      errorType: 'default-error'
    }
  }
}) => {
  const data = {
    action,
    prefixKey: 'content-management-details-lib.notifications.errors.shared',
    response,
    additionalTranslationOptions: options
  };
  return {
    message: getErrorMessage(data),
    titleText: getErrorTitle(data)
  };
};
export const showErrorNotification = ({
  options = {},
  action,
  response = {
    responseJSON: {
      errorType: 'default-error'
    }
  }
}) => {
  const {
    titleText,
    message
  } = getErrorData({
    options,
    action,
    response
  });
  FloatingAlertStore.addAlert({
    message,
    titleText,
    type: 'danger'
  });
};